export const drawerWidth: number = 240;
